const NovedadesTabItemFill = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            {...props}
        >
            <path
                d="M6.7232 20.72C5.19207 18.578 1.59978 13.5061 1.18364 12.9239C1.17346 12.9095 1.16809 12.8925 1.16809 12.8749V0.584946C1.16809 0.537943 1.20597 0.5 1.2529 0.5H8.74458C8.77285 0.5 8.79914 0.514158 8.81497 0.537376L15.7995 10.8889C15.8009 10.8909 15.8023 10.8928 15.8037 10.8948C15.8696 10.9761 18.5168 13.639 17.129 14.1453C15.7657 14.6427 16.3425 12.4629 16.5385 10.5845C16.5503 10.4718 16.5563 10.3583 16.5563 10.245L16.5913 0.584663C16.5913 0.537943 16.6295 0.5 16.6761 0.5H24.0833C24.1302 0.5 24.1681 0.537943 24.1681 0.584946V23.3179C24.1681 23.4184 24.0867 23.5 23.9863 23.5H16.6357C16.6083 23.5 16.5823 23.4866 16.5664 23.464L8.89893 12.6263C8.85115 12.5586 8.74486 12.5926 8.74486 12.6756V23.2355C8.74486 23.3182 8.63913 23.3521 8.59107 23.285L8.57608 23.2641C8.57128 23.2573 6.72773 20.7265 6.7232 20.72Z"
                fill="#686058"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default NovedadesTabItemFill
